import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import * as Sentry from '@sentry/angular-ivy';

import { AppModule } from '@app/app.module';
import { environment } from './environments/environment';
import packageInfo from '../package.json';


if (environment.production) {
  enableProdMode();
}


if (['dev', 'production'].includes(environment.NAME)) {
  Sentry.init({
    dsn: environment.SENTRY_DSN,
    environment: environment.NAME,
    release: 'v' + packageInfo.version,

    integrations: [
      // Registers and configures the Tracing integration,
      // which automatically instruments your application to monitor its
      // performance, including custom Angular routing instrumentation
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.routingInstrumentation,
      }),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.2,
  });
}

if(['production'].includes(environment.NAME)) {  
  const rewardlyScript1 = document.createElement('script');
  rewardlyScript1.textContent = `(function(w,r){w._rwq=r;w[r]=w[r]||function(){(w[r].q=w[r].q||[]).push(arguments)}})(window,'rewardful')`
  document.head.appendChild(rewardlyScript1)

  const rewardlyScript2 = document.createElement('script');
  rewardlyScript2.src = 'https://r.wdfl.co/rw.js'
  rewardlyScript2.async = true;
  rewardlyScript2.setAttribute('data-rewardful', 'e0d955')

  rewardlyScript2.onerror = () => {
    console.error('Failed to load Rewardful script');
  };
  document.head.appendChild(rewardlyScript2)
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
